import React from "react";
//import { MapContext } from "./Map";
import { mapSymbology } from "./MapStyles";
import { ntaMapSymbology } from "./MapStyles";

export const Legend = (isBrowser = true) => {
  const { colors, breaks, label } = mapSymbology;
  return (
    <div className="map-overlay legend mixed">
      <div className="slider-legend-title mb-0"> {label} </div>
      <div className="columns is-mobile mt-1 pt-1 px-4 pb-0 mb-0">
        {colors.map((color, i) => (
          <div
            className="column is-one-fifth has-text-centered p-1"
            key={i}
            style={{
              backgroundColor: color,
              float: "left",
              width: 50,
              height: 50,
              color: i < 2 ? "#111" : "#ebebeb",
            }}
          >
            {i % 1 === 0 && breaks[i].toLocaleString()}
          </div>
        ))}
      </div>
    </div>
  );
};

export const NtaLegend = (isBrowser) => {
  const { colors, breaks, label } = ntaMapSymbology;

  // Create a linear gradient from the colors
  const gradient = `linear-gradient(to right, ${colors.join(", ")})`;

  return (
    <div className="map-overlay legend mixed">
      <div className="slider-legend-title mb-0"> {label} </div>
      <div className="gradient-legend-container mt-1 pt-1 px-4 pb-0 mb-0">
        <div
          className="gradient-legend-bar"
          style={{
            background: gradient,
            height: 20, // Adjust height as needed
            borderRadius: 5, // Optional: adds rounded corners
          }}
        />
        <div className="gradient-legend-breaks has-text-centered">
          {breaks.map((breakPoint, i) => (
            <span
              key={i}
              style={{
                position: "absolute",
                left: `${(i / (breaks.length - 1)) * 100}%`,
                transform: "translateX(-50%)",
                color: i < 2 ? "#111" : "#ebebeb", // Adjust text color as needed
              }}
            >
              {breakPoint}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

/*

export const NtaLegend = (isBrowser) => {
  const { colors, breaks, label } = ntaMapSymbology;
  return (
    <div className="map-overlay legend mixed">
      <div className="slider-legend-title mb-0"> {label} </div>
      <div className="columns is-mobile mt-1 pt-1 px-4 pb-0 mb-0">
        {colors.map((color, i) => (
          <div
            className="column is-one-fifth has-text-centered p-1"
            key={i}
            style={{
              backgroundColor: color,
              float: "left",
              width: 50,
              height: 50,
              color: i < 2 ? "#111" : "#ebebeb",
            }}
          >
            {i % 1 === 0 && breaks[i].toLocaleString()}
          </div>
        ))}
      </div>
    </div>
  );
};*/
